// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      .activity-cell-display {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 4px;
        cursor: pointer;
        white-space: normal !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
      }
    `, "",{"version":3,"sources":["webpack://./src/app/pages/logbooks/render/opNatureSelector.ts"],"names":[],"mappings":";MACM;QACE,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,WAAW;QACX,YAAY;QACZ,eAAe;QACf,8BAA8B;QAC9B,2BAA2B;QAC3B,kCAAkC;MACpC","sourcesContent":["\n      .activity-cell-display {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        width: 100%;\n        padding: 4px;\n        cursor: pointer;\n        white-space: normal !important;\n        overflow: hidden !important;\n        text-overflow: ellipsis !important;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
